import { useState } from "react";
import { IconButton, Stack, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import StopIcon from "@mui/icons-material/Stop";
import { colors } from "@utils/colors";

export const Composer = ({
  onSend,
  onStop,
  isStreaming,
}: {
  onSend: (content: string) => void;
  onStop: () => void;
  isStreaming: boolean;
}) => {
  const [value, setValue] = useState("");

  const submit = () => {
    if (!value.trim() || isStreaming) return;
    onSend(value);
    setValue("");
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="flex-end"
      sx={{ p: 1.5, borderTop: (t) => `1px solid ${t.palette.divider}` }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={4}
        size="small"
        placeholder="Ask SM AI…"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            submit();
          }
        }}
      />
      <IconButton
        onClick={isStreaming ? onStop : submit}
        disabled={!isStreaming && !value.trim()}
        sx={{ bgcolor: colors.blue, color: colors.surface, "&:hover": { bgcolor: colors.blueHover } }}
      >
        {isStreaming ? <StopIcon fontSize="small" /> : <SendIcon fontSize="small" />}
      </IconButton>
    </Stack>
  );
};
